define('lib/backbone/Backbone.PodioOffsetPaginatedCollection',['require','underscore','lib/backbone/Backbone.PodioCollection'],function(require) {

  var _ = require('underscore');
  var CollectionPodioBase = require('lib/backbone/Backbone.PodioCollection');

  return CollectionPodioBase.extend({
    fetchWithPost: false,           /* do a POST request instead of GET */
    itemsPerPage: 15,
    endReached: false,
    pendingDeletion: [],

    setItemsPerPage: function(number) {
      this.itemsPerPage = number;
    },

    fetch: function(options) {
      var data;
      var self = this;
      options = options || {};

      if (!options.silent) {
        this.trigger('offsetPagination:loadingPage', options.offset+options.limit-1);
      }
      options.data = options.data || {};
      _.extend(options.data, {
        offset: options.offset,
        limit: options.limit
      });

      if (this.fetchWithPost) {
        data = options.data;
        delete options.data;

        return this.request('post', this.url, data, options).done(function(responseData) {
          var method = options.reset ? 'reset' : 'set';
          var resp = self.parse(responseData);

          self[method](resp, options);
          if (options.success) {
            options.success(self, resp, options);
          }
        });
      } else {
        return this._super(options);
      }
    },

    getPage: function(offset, options) {
      offset = offset || 0;
      if (offset === 0 || offset < this.length) {
        this.endReached = false;
      }

      this.appendCollection = offset < this.length ? false : offset !== 0;

      options = options || {};
      _.extend(options, {
        offset: offset,
        limit: this.itemsPerPage + 1,
        silentLoading: this.appendCollection
      });

      if (this.appendCollection) {
        options.remove = false;
      } else {
        options.reset = true;
      }

      var fetchPromise = this.fetch(options);

      this.trigger('change:pageLoading', true);
      fetchPromise.then(function() {
        this.trigger('change:pageLoading', false);
      }.bind(this));

      return fetchPromise;
    },

    getNextPage: function(options) {
      return this.getPage(this.length, options);
    },

    parse: function(response) {
      var self = this;
      var results;
      var finalResults;

      if (response.data && response.status && response.status !== 'ok') {
        return;
      }

      // handle both API proxy and Rails responses
      if (response.data && response.data.object) {
        results = response.data.object;
      } else {
        results = response;
      }

      if (this.appendCollection && (results.length > this.itemsPerPage)) {
        finalResults = results.slice(0, -1);
      } else if (!this.appendCollection && results.length > this.itemsPerPage) {
        finalResults = results.slice(0, -1);
      } else {
        finalResults = results;
        this.endReached = true;
        this.trigger('noResultsLeft');
      }

      if (response.data && response.data.meta) {
        this.count = response.data.meta.count;
        this.totalCount = response.data.meta.total_count;
      }

      // Remove any items from the collection that are pending deletion.
      if (this.pendingDeletion.length) {
        finalResults = _.filter(finalResults, function(result){
          return !_.include(self.pendingDeletion, result.id);
        });
      }

      return finalResults;
    }

  });

});

